import httpUtil from "@/utils/httpUtil";

export const selectCodeList = params => httpUtil.get("/storeCode", params);

export const selectCodeDetailList = params => httpUtil.get("/storeCode/codeDetail", params);


export const addStoreCode = params => httpUtil.post("/storeCode/addCode", params);
export const editStoreCode = params => httpUtil.post("/storeCode/edit", params);


export const selectWareCode = params => httpUtil.get("/storeCode/wareCodeDetail", params);

export const selectPrintCode = params => httpUtil.get("/storeCode/getPrintList", params);

export const selectCode = params => httpUtil.get("/store/app/getCodeList", params);
export const deleteCode = params => httpUtil.post("/storeCode/deleteCode", params);

export const selectClass = params => httpUtil.get("/storeCode/getQueryClass", params);
export const selectList = params => httpUtil.post("/storeCode/print", params);
export const updataStatus = params => httpUtil.post("/storeCode/updataStatus", params);
